import { Component, OnDestroy, OnInit } from '@angular/core';
import { CoinflipService } from '../coinflip.service';
import { ModalService } from '@app/modal/modal.service';
import { COINFLIP_SIDE_BLUE, COINFLIP_SIDE_RED, Coinflip } from '@models/coinflip.interface';
import { CoinflipCoinComponent } from '@shared/coinflip-coin/coinflip-coin.component';
import { CurrencyComponent } from '@shared/currency/currency.component';
import { IconComponent } from '@shared/icon/icon.component';
import { ItemListComponent } from '@shared/item-list/item-list.component';
import { LevelNewComponent } from '@shared/level-new/level-new.component';
import { ModalBoxComponent } from '@shared/modal-box/modal-box.component';

@Component({
  selector: 'app-coinflip-won-modal',
  templateUrl: './coinflip-won-modal.component.html',
  styleUrls: ['./coinflip-won-modal.component.scss'],
  imports: [ModalBoxComponent, IconComponent, CurrencyComponent, CoinflipCoinComponent, LevelNewComponent, ItemListComponent],
})
export class CoinflipWonModalComponent implements OnInit, OnDestroy {
  data: Coinflip;
  remainingTime: number = 10;
  selectedCoin: number = COINFLIP_SIDE_BLUE;
  interval: any;
  winValue = 0;
  readonly blueSide = COINFLIP_SIDE_BLUE;
  readonly redSide = COINFLIP_SIDE_RED;

  constructor(public modalService: ModalService, private coinflipService: CoinflipService) {
    this.data = this.modalService.data;
    this.modalService.disableWrapperOverflow = true;

    this.selectedCoin = this.data?.winner?.side ?? COINFLIP_SIDE_BLUE;
  }

  ngOnInit(): void {
    this.startTimer();

    setTimeout(() => {
      this.winValue = this.data.value;
    }, 1000);
  }

  startTimer(): void {
    this.interval = setInterval(() => {
      this.remainingTime--;
      if (this.remainingTime === 0) {
        clearInterval(this.interval);
        this.onTimerComplete();
      }
    }, 1000);
  }

  async onTimerComplete() {
    try {
      await this.coinflipService.claimWinnings(this.data.gameid);
    } catch {
      // Fired from a timer, so a rejection here has no caller to catch it.
    }

    this.modalService.close();
  }

  async doubleDownButton() {
    // Must stop the auto-claim countdown before awaiting, or t=10s emits cf_claim for a pot already being rehosted.
    this.clearTimer();

    try {
      await this.coinflipService.doubleDown({
        id: this.data.gameid,
        side: this.selectedCoin,
      });
    } catch {
      // The socket layer already toasts the rejection; just close so no timer and no emit stay live.
    }

    this.modalService.close();
  }

  selectCoin(coin: number) {
    this.selectedCoin = coin;
  }

  async claimWinningsButton() {
    // Must stop the auto-claim countdown before awaiting, or t=10s emits a second cf_claim for the same pot.
    this.clearTimer();

    try {
      await this.coinflipService.claimWinnings(this.data.gameid);
    } catch {
      // The socket layer already toasts the rejection; just close so no timer and no emit stay live.
    }

    this.modalService.close();
  }

  private clearTimer(): void {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  }

  ngOnDestroy(): void {
    this.clearTimer();
  }
}
